import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps, TextInput } from 'react-admin';
import { BillboardList } from './BillboardList';
import { BillboardDatagrid } from './BillboardDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { Billboard } from './Billboard';

export * from './Billboard';
export * from './BillboardCreate';
export * from './BillboardDatagrid';
export * from './BillboardEdit';
export * from './BillboardList';
export * from './BillboardShow';

const BillboardsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'featuredImageUrl', header: 'Feature image' },
	{ key: 'title', header: 'Title' }
];

export const BillboardsData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: Billboard) => entity;

	const billboardsFilter = [
		<TextInput source="title" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('באנרים', exportFields, exportDataMapper)}
				{...props}
				filters={billboardsFilter}
				bulkActionButtons={<BillboardsBulkActionButtons/>}
				title="BILLBOARDS"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <BillboardList/> : <BillboardDatagrid/>}
			</List>
		</Fragment>
	);
};
